<script>
/**
 * ****************************************************************************
 * @description     :   MainMenu
 * @created at      :   2024/05/22
 * @created by      :   ANS903 – phuongdt@ans-asia.com
 * @package         :   Move
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */
import { mapState, mapActions } from 'vuex';
import store from '@/store';
import MenuLeft from '@/shared/menu/store';
import helpers from '@/utils/helpers';
import template from './template.html';
import ItemLeftMenu from './item';
import _ from 'lodash';

const MainMenu = {
    name: 'Menu',
    template: template,
    components: {
        ItemLeftMenu
    },
    props: {
        isPinIconLeftMenu: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            // list
            items: { list: [] },
            listRefInMenus: [],

            // drag drop, touch
            fromIndex: null,
            startDragDrop: false,
            draggable: false,
            dragging: false,
            isDragOverOrTouchMove: false,
            isAnimating: false,
            eventListeners: [],

            // check touch => click
            touchStartTime: null,
            touchEndTime: null,

            // others
            itemActive: null,
            authority: null,
            isMobile: helpers.checkIfMobile()
        };
    },
    beforeCreate() {
        if (!store.hasModule('MenuLeft')) {
            store.registerModule('MenuLeft', MenuLeft);
        }

        // this.itemsSource = this.$store.state.MenuLeft.data.itemsSource ?? {};
    },
    created() {
        this.authority = localStorage.getItem('authority');
        ({ page: this.page, authenkey: this.authenkey } = this.pageAndAuthenkey(this.$route.name, this.authority));
        this.referMenu();
        this.triggerAfterRouterChange();
    },
    mounted() {
        this.addEventListeners();
        // window.addEventListener('storage', this.handleStorageChange);
    },
    beforeUnmount() {
        document.body.style.overflow = 'auto';
        this.removeEventListeners();
        // window.removeEventListener('storage', this.handleStorageChange);
    },
    watch: {
        $route(to) {
            if (to) {
                this.triggerAfterRouterChange();
            }
        },
        'items.list'() {
            this.$nextTick(() => {
                if (this.$refs.listItems) {
                    this.listRefInMenus = Array.from(this.$refs.listItems.children);

                    this.removeEventListeners();
                    this.addEventListeners();
                }
            });
        }
        // draggableAndisShowLeftMenu(v) {
        //     document.body.style.overflow = v ? 'hidden' : 'auto';
        // },
        // 'data.itemsSource'(valueNew = {}) {
        //     this.itemsSource = { ...valueNew };
        //     this.referMenu();
        // }
    },
    computed: {
        ...mapState('app', ['menus', 'isShowHalfMenu', 'isShowFullMenu', 'user', 'isShowLeftMenu']),
        urlAfterLogin() {
            return localStorage.getItem('urlAfterLogin') || '/';
        }
        // draggableAndisShowLeftMenu() {
        //     return this.draggable && this.isShowLeftMenu;
        // }
        // classMore() {
        //     return this.draggable ? { classUl: 'clear-style' } : {};
        // }
    },
    methods: {
        ...mapActions('app', ['showFullMenu']),
        onClickOutside: function (event) {
            if (
                // event.target.classList &&
                // !event.target.classList.contains('gn-menu-wrapper') &&
                // !event.target.classList.contains('fa-solid') &&
                // !event.target.classList.contains('fa-bars') &&
                // !event.target.classList.contains('fa-lg')
                !(event?.target && typeof event.target.closest === 'function' && event.target.closest('#toggle-menu')) &&
                helpers.checkIfMobile()
            ) {
                this.$emit('handle-left-menu', false);
            }
        },
        // handleStorageChange(event) {
        //     if (event.key === 'listMenu') {
        //         this.items = JSON.parse(event.newValue) || [];
        //     }
        // },
        pageAndAuthenkey(routeName, authority) {
            const mgn = { page: 'MNG', authenkey: this.user?.user_id };
            const cus = { page: 'CUS', authenkey: this.user?.personal_id };
            if (routeName.toLowerCase().includes('mng')) {
                return mgn;
            } else if (routeName.toLowerCase().includes('cus')) {
                return cus;
            } else {
                // authority = 1 => CUS
                // authority = 2 => MNG
                if (authority === '2') {
                    return mgn;
                } else if (authority === '1') {
                    return cus;
                }
            }
            return { page: false, authenkey: false };
        },
        referMenu() {
            // check login
            const user = JSON.parse(localStorage.getItem('userInfo'));
            if (_.isEmpty(user)) return;

            // check authority
            if (this.authority === null) {
                this.items = { list: [] };
                return;
            }

            const { cusRole: role = null, basic_estimate } = this.user;

            // Helper: extract menu structure (name + children)
            function extractMenuStructure(list) {
                return (list || []).map((item) => {
                    if (item.children && item.children.list) {
                        return {
                            name: item.name,
                            title: item.title,
                            to: item.to,
                            children: extractMenuStructure(item.children.list)
                        };
                    }
                    return { name: item.name, title: item.title, to: item.to };
                });
            }

            // Helper: compare two menu structures recursively
            function isSameMenuStructure(listA, listB) {
                if (!Array.isArray(listA) || !Array.isArray(listB)) return false;
                if (listA.length !== listB.length) return false;

                for (let i = 0; i < listA.length; i++) {
                    if (listA[i].name !== listB[i].name) return false;
                    if (listA[i].title !== listB[i].title) return false;
                    if (listA[i].to !== listB[i].to) return false;

                    const hasChildrenA = listA[i].children && Array.isArray(listA[i].children);
                    const hasChildrenB = listB[i].children && Array.isArray(listB[i].children);

                    if (hasChildrenA !== hasChildrenB) return false;

                    if (hasChildrenA && hasChildrenB) {
                        if (!isSameMenuStructure(listA[i].children, listB[i].children)) return false;
                    }
                }
                return true;
            }

            // get listMenu from DB first, then check localStorage
            const getItems = new Promise((resolve, reject) => {
                // Step 1: Dispatch MenuLeft/fetchMenuLeft first
                this.$store
                    .dispatch('MenuLeft/fetchMenuLeft', this.page)
                    .then(() => {
                        const dispatchData = this.$store.state.MenuLeft.listMenu;
                        // Step 2: Check localStorage
                        const listInStorage = localStorage.getItem('listMenu');

                        if (helpers.isValidJSON(listInStorage) && Object.keys(JSON.parse(listInStorage)).includes(this.authenkey)) {
                            const localStorageData = JSON.parse(listInStorage)?.[this.authenkey];

                            // Step 3: Compare dispatch data with localStorage data (recursive structure)
                            const dispatchStructure = extractMenuStructure(dispatchData?.list || []);
                            const localStorageStructure = extractMenuStructure(localStorageData?.list || []);

                            const isSameStructure = isSameMenuStructure(dispatchStructure, localStorageStructure);

                            if (isSameStructure) {
                                // Use localStorage data if structure matches
                                resolve(localStorageData);
                            } else {
                                // Use dispatch data if not match, and update localStorage
                                localStorage.setItem(
                                    'listMenu',
                                    JSON.stringify({
                                        ...JSON.parse(listInStorage),
                                        [this.authenkey]: dispatchData
                                    })
                                );
                                resolve(dispatchData);
                            }
                        } else {
                            // No valid localStorage data, use dispatch data and set localStorage
                            const existingStorage = helpers.isValidJSON(listInStorage) ? JSON.parse(listInStorage) : {};
                            localStorage.setItem(
                                'listMenu',
                                JSON.stringify({
                                    ...existingStorage,
                                    [this.authenkey]: dispatchData
                                })
                            );
                            resolve(dispatchData);
                        }
                    })
                    .catch(() => {
                        reject({ list: [] });
                    });
            });

            // set items => remove items by condition
            getItems
                .then((itemsRes) => {
                    this.items = { ...(itemsRes ?? {}) };
                    // remove items by authority
                    if (this.authority === '1') {
                        // role = 1: admin; others: common
                        if (role === '0') {
                            this.items.list = this.items.list.filter((v) => v.name !== 'CUS_Client003');
                        }
                    }
                    // remove items by MFIL_002.簡単見積有無
                    if (basic_estimate === '1') {
                        this.items.list = this.items.list.filter((v) => v.name !== 'CUS_Order001');
                    }
                })
                .catch(() => {
                    this.items = { list: [] };
                });
        },
        addEventListeners(options = { passive: false }) {
            this.listRefInMenus.forEach((item, index) => {
                // declare
                const start = (e) => this.onDragOrTouchStart(e, index);
                const move = (e) => this.onDragOverOrTouchMove(e, index);
                const end = (e) => this.onDragOrTouchEnd(e, index);
                // save
                this.eventListeners[index] = {};
                this.eventListeners[index]['start'] = start;
                this.eventListeners[index]['move'] = move;
                this.eventListeners[index]['end'] = end;

                // add
                item.addEventListener('touchstart', start, options);
                item.addEventListener('touchmove', move, options);
                item.addEventListener('touchend', end, options);
            });
        },
        removeEventListeners(options = { passive: false }) {
            this.listRefInMenus.forEach((item, index) => {
                if (this.eventListeners[index]) {
                    const start = this.eventListeners[index]['start'];
                    const move = this.eventListeners[index]['move'];
                    const end = this.eventListeners[index]['end'];

                    item.removeEventListener('touchstart', start, options);
                    item.removeEventListener('touchmove', move, options);
                    item.removeEventListener('touchend', end, options);
                }
            });
        },
        triggerAfterRouterChange() {
            // hide left menu
            this.$emit('handle-left-menu', false);
        },
        updateActiveItemByRouter() {
            let newList = [...this.items.list];

            // step 1: other position => set inactive
            let list = this.setInactive({ list: [...this.items.list] });

            const routeName = this.$route.name;

            // step 2: get position active (if any)
            let position = this.getPosition({
                list,
                routeName
            });

            // step 3: set active by position
            if (Array.isArray(position) && position.length > 0) {
                newList = this.setActive({
                    list,
                    hierarchyPosition: position
                });
            }

            return newList;
        },
        setInactive({ list = [] }) {
            // parent
            list.forEach((value) => {
                value['class'] = value['class']
                    .split(' ')
                    .filter((v) => !['router-link-active', 'router-link-exact-active'].includes(v))
                    .join(' ');
            });

            // is has children
            for (let i = 0, lengthItems = list.length; i < lengthItems; i++) {
                const { children } = list[i] || {};
                if (typeof children === 'object' && !Array.isArray(children) && children !== null) {
                    list[i].children.list = this.setInactive({
                        list: children.list || []
                    });
                }
            }

            return list;
        },
        getPosition({ list = [], routeName, hierarchyPosition = [] }) {
            let position = list.findIndex((v) => v.name === routeName);
            if (position === -1) {
                position = list.findIndex((v) => {
                    return v.relatedName && v.relatedName.length > 0 && v.relatedName.includes(routeName);
                });
            }

            if (position > -1) {
                hierarchyPosition.push(position);

                // is has children
                const { children } = list[position];
                if (typeof children === 'object' && !Array.isArray(children) && children !== null) {
                    hierarchyPosition = this.getPosition({
                        list: children.list,
                        routeName,
                        hierarchyPosition
                    });
                }
            }

            return hierarchyPosition;
        },
        setActive({ list = [], hierarchyPosition = [] }) {
            const position = hierarchyPosition[0];

            hierarchyPosition.shift();

            if (typeof position === 'number') {
                list[position]['class'] = 'router-link-active router-link-exact-active';

                if (hierarchyPosition.length > 0) {
                    list[position].children.list = this.setActive({
                        list: list[position].children.list,
                        hierarchyPosition
                    });
                }
            }

            return list;
        },
        onDragOrTouchStart(event, index) {
            //////////////////////////////////////////////
            // touchstart
            // if (event.type === 'touchstart') {
            //     if (this.draggable) {
            //         // prevent scroll,... events in mobile, tablet (all equipments has touch event)
            //         event.preventDefault();
            //         // tracking click after touch
            //         this.touchStartTime = performance.now();
            //     } else {
            //         this.touchStartTime = null;
            //         return;
            //     }
            // }

            //////////////////////////////////////////////
            // dragstart
            if (!this.draggable) return;
            if (event.type === 'dragstart') {
                this.handleListChildren();
                event.dataTransfer.effectAllowed = 'none';
                event.dataTransfer.dropEffect = 'none';
            }

            //////////////////////////////////////////////
            // shared
            // step 1
            // this.handleListChildren();

            // step 2 - init (shared)
            this.startDragDrop = true;
            this.fromIndex = index;

            // step 3 (shared)
            // requestAnimationFrame(() => {
            this.items.list[index]['class'] = this.items.list[index]['class'] + ' dragging';
            this.dragging = true;
            // });
        },
        onDragOverOrTouchMove(event, toIndex) {
            if (!this.draggable || !this.startDragDrop || (event.type === 'dragover' && this.fromIndex === toIndex) || this.isAnimating) return;

            requestAnimationFrame(async () => {
                if (event.type === 'touchmove') {
                    const touch = event.touches[0];
                    const overElement = this.getTargetElement(touch.clientX, touch.clientY);

                    if (!overElement) return;

                    toIndex = overElement.dataset.index ? parseInt(overElement.dataset.index) : -1;
                }

                if (event.type === 'dragover') {
                    event.dataTransfer.dropEffect = 'none';
                }

                const fromIndex = this.fromIndex;

                // smooth animation and update order item
                if (!this.isAnimating && this.fromIndex !== toIndex && toIndex !== -1) {
                    // this.touchStartTime = null;
                    this.isAnimating = true;
                    if (event.type === 'touchmove') {
                        this.handleListChildren();
                    }
                    await this.animateSwap(fromIndex, toIndex);

                    this.fromIndex = toIndex;
                    this.isAnimating = false;
                }
            });
        },
        getTargetElement(x, y) {
            for (const el of this.listRefInMenus) {
                const rect = el.getBoundingClientRect();
                if (x >= rect.left && x <= rect.right && y >= rect.top && y <= rect.bottom) {
                    return el;
                }
            }
            return null;
        },
        animateSwap(fromIndex, toIndex) {
            if (fromIndex === null || toIndex === null) return;

            const children = this.listRefInMenus;
            const childFromIndex = children[fromIndex] || null;

            if (!childFromIndex) {
                return;
            }

            const translateY = (toIndex - fromIndex) * childFromIndex.offsetHeight;
            const animateItem = (item, value) => {
                item.style.transition = 'transform 0.1s cubic-bezier(0.25, 0.8, 0.5, 1)';
                item.style.transform = `translateY(${value}px)`;
                item.style.willChange = 'transform';
            };

            return new Promise((resolve) => {
                const [fromItem, toItem] = [children[fromIndex], children[toIndex]];
                animateItem(fromItem, translateY);
                animateItem(toItem, -translateY);

                setTimeout(() => {
                    [fromItem, toItem].forEach((item) => {
                        item.style.transition = item.style.transform = '';
                    });
                    this.swapItems(fromIndex, toIndex);
                    resolve();
                }, 110);
            });
        },
        swapItems(fromIndex, toIndex) {
            // if swap after dragEnd
            if (this.fromIndex === null && this.items.list[fromIndex]) {
                this.items.list[fromIndex]['class'] = this.items.list[fromIndex]['class']
                    .split(' ')
                    .filter((v) => v !== 'dragging')
                    .join(' ');
                this.dragging = false;
            }

            const updatedList = [...this.items.list];
            const temp = updatedList[fromIndex];
            updatedList.splice(fromIndex, 1);
            updatedList.splice(toIndex, 0, temp);
            this.items.list = updatedList;
        },
        onDragOrTouchEnd() {
            // this.touchEndTime = performance.now();
            // // trigger click after touch
            // if (
            //     this.draggable &&
            //     event.type === 'touchend' &&
            //     this.touchStartTime &&
            //     this.touchEndTime &&
            //     this.touchEndTime - this.touchStartTime < 200
            // ) {
            //     // trigger click event order to natigative page (if any)
            //     // event.target.click();

            //     this.touchStartTime = null;
            //     this.touchEndTime = null;
            // }

            if (!this.draggable) return;

            this.startDragDrop = false;

            requestAnimationFrame(() => {
                if (this.items.list[this.fromIndex]) {
                    this.items.list[this.fromIndex]['class'] = this.items.list[this.fromIndex]['class']
                        .split(' ')
                        .filter((v) => v !== 'dragging')
                        .join(' ');
                    this.dragging = false;
                }
                this.fromIndex = null;

                // update listMenu to storage
                this.updateListMenu();
            });
        },
        onClickOrHandleAfterTouch(event, index) {
            this.handleListChildren(index);
        },
        handleListChildren(index = -1) {
            // current element
            if (
                index > -1 &&
                this.$refs.listItems &&
                this.$refs.listItems.children &&
                this.$refs.listItems.children[index] &&
                this.$refs.listItems.children[index].querySelector('.list-child')
            ) {
                const currentEl = this.$refs.listItems.children[index].querySelector('.list-child');

                if (currentEl.style.maxHeight) {
                    currentEl.style.maxHeight = null;
                } else {
                    currentEl.style.maxHeight = currentEl.scrollHeight + 'px';
                }
            }

            // other element
            const listChild = this.$refs.listItems.children;
            const length = listChild.length;

            for (let i = 0; i < length; i++) {
                if (i === index) continue;
                const otherEl = listChild[i].querySelector('.list-child');
                if (otherEl && otherEl.style.maxHeight) {
                    otherEl.style.maxHeight = null;
                }
            }

            // if (this.items.list) {
            //     let clone = [...this.items.list];

            //     // clear 'show' except position index
            //     clone.forEach((v, i) => {
            //         if (i !== index) {
            //             if (v.children) {
            //                 v.children.class = '';
            //             }
            //         }
            //     });

            // // toggle
            // if (index > -1 && clone[index] && clone[index].children) {
            //     let child = { ...clone[index].children };
            //     child.class = child.class === '' ? 'show' : '';
            //     clone[index].children = child;
            // }

            // this.items.list = clone;
            // }
        },
        updateListMenu() {
            const listMenu = localStorage.getItem('listMenu');
            if (helpers.isValidJSON(listMenu)) {
                const listMenuParse = JSON.parse(listMenu);
                localStorage.setItem(
                    'listMenu',
                    JSON.stringify({
                        ...listMenuParse,
                        [this.authenkey]: { ...this.items }
                    })
                );
            } else {
                localStorage.setItem('listMenu', JSON.stringify({ [this.authenkey]: { ...this.items } }));
            }
        }
    }
};
export default MainMenu;
</script>
